import { Decodable } from './_decodable';
import { Product } from './product';
import { Unit } from './unit';

class QuoteItem extends Decodable {
  id!: number;
  name!: string;
  unitId: number = 1;
  quantity: number = 0;
  productId?: number;
  product?: Product;
  unit?: Unit;

  protected _map = {
    createdAt: (e) => this.parseDate(e),
    updatedAt: (e) => this.parseDate(e),
    product: (e) => Product.parse(e),
    unit: (e) => Unit.parse(e),
  };
}

export { QuoteItem };
